import { Header } from "@/components/features/layout/header";

export const TERMS_TEXT = `AI面談サービス利用規約（ベータ版）

第1条　（適用範囲）
本規約は、株式会社スリーシェイク（以下「当社」といいます。）が提供するAI面談サービス（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用する利用者は、本規約に同意の上、本サービスを利用するものとします。

第2条　（用語の定義）
本規約において、次の用語は以下の意味で使用します。
	1.	「ユーザー」：本規約に同意し、本サービスを利用する個人（個人事業主を含みます。）。
	2.	「利用契約」：本規約に基づき当社とユーザーとの間に成立する、本サービスの利用に関する契約。

第3条　（本サービスの内容）
	1.	本サービスは、ユーザーがアップロードした履歴書及び職務経歴書等の情報に基づき、AIが音声にて面談（質問・ヒアリング）を行い、その回答データを記録・分析するサービスです。
	2.	当社は、本サービスを通じて得られたデータを、当社が運営するフリーランス向け案件紹介サービスにおけるマッチング及び案件提案のために利用します。

第4条　（利用環境の整備）
ユーザーは、自己の費用と責任において、本サービスを利用するために必要な通信機器、ソフトウェア、インターネット接続環境等を準備するものとします。当社は、ユーザーの利用環境について一切の関与をせず、その整備に関する助言等の義務も負いません。

第5条　（契約の成立及び拒絶事由）
	1.	ユーザーが本規約に同意し、本サービスの利用を開始した時点で、当社とユーザーとの間に利用契約が成立します。
	2.	当社は、ユーザーが以下の各号のいずれかに該当すると判断した場合、事前の通知なく本サービスの提供を拒否、又は利用を停止できるものとします。当社はこれによりユーザーに生じた損害について、一切の責任を負いません。
		(1)	本規約の規定に違反するおそれがある場合
		(2)	ユーザーが提供した情報等に虚偽、誤記、又は記載漏れがある場合
		(3)	過去に当社の提供するサービスにおいて、規約違反等により契約を解除された事実がある場合
		(4)	未成年者等の制限能力者であり、法定代理人等の同意を得ていない場合
		(5)	第14条に違反すると認められる場合
		(6)	その他、当社が本サービスの提供を不適当と合理的に判断した場合

第6条　（データの取得及び利用目的）
当社は、本サービスの利用に伴い、次の各号のデータ（以下「本件データ」といいます。）を取得します。
	(1)	ユーザーがアップロードした履歴書、職務経歴書等の書類データ（ユーザーの個人情報を含みます。）
	(2)	AI面談におけるユーザーの音声データ、及びそれをテキスト化したデータ
	(3)	面談結果の分析・評価データ

第7条　（データの管理及び第三者提供）
	1.	当社は、本件データを当社のプライバシーポリシーに基づき、厳重に管理します。
	2.	当社は、ユーザーへの適切な案件紹介・マッチングを目的として、本件データの一部又は全部（機密情報や特定の個人を識別できる情報を除いた経歴サマリー、面談の評価フィードバック等を含みます。）を、将来的に求人企業に対して開示・共有することがあり、ユーザーはあらかじめこれに同意するものとします。

第8条　（知的財産権の帰属）
本サービスにおいてAIが生成した質問内容、システム、及び面談結果の分析データに関する一切の知的財産権（特許権、実用新案権、意匠権、著作権、商標権その他の知的財産権の総称をいい、外国の法令に基づく同種の権利も含みます。）は、当社又は正当な権利者（当社に対してライセンスを付与する第三者を含みます。）に帰属します。ユーザーは、私的使用の範囲を超えてこれらを利用（転載、複製、公開等）することはできません。

第9条　（業務委託）
当社は、本サービスに関する業務の全部又は一部を、当社の責任において第三者に委託することができるものとします。

第10条　（禁止事項）
ユーザーは、本サービスの利用にあたり、次の各号の行為を行ってはなりません。
	(1)	当社又は第三者の知的財産権、肖像権、プライバシー、その他の権利を侵害する行為
	(2)	本サービスのシステムに対する攻撃（プロンプトインジェクション、リバースエンジニアリング等を含みますが、これらに限られません。）、本サービスの全部又は一部を複製、改変、改ざんする行為、及び本サービスのシステムに過度な負荷をかける行為
	(3)	プログラム等を用いた自動実行や、データのスクレイピング行為
	(4)	コンピューターウィルス等の有害なプログラムを送信・配布する行為
	(5)	他者へのなりすまし、又は虚偽の経歴や情報を登録・回答する行為
	(6)	AI面談の音声や質問内容を録音・録画し、第三者に公開又はSNS等に転載する行為
	(7)	本サービスの運営を妨害する行為、又は当社のシステムに不当な負荷をかける行為
	(8)	その他、法令や公序良俗に反する行為、又は当社が不適切と判断する行為

第11条　（免責事項）
	1.	当社は、ユーザーに対し、次の各号に掲げる事項についていかなる保証も行わないものとします。
		(1)	本サービスによるAI面談の結果、ユーザーに対する特定の案件紹介や成約が行われること
		(2)	本サービスによって提供又は出力される情報（本サービスによるAI面談の結果を含むが、これに限られない。）の正確性、完全性、最新性、安全性及び特定の目的への適合性
		(3)	本サービスの利用が、第三者の知的財産権その他の権利若しくは利益を侵害していないこと、又は本サービスの利用に第三者の許諾を必要としないこと
		(4)	本サービスが常時提供可能であること
	2.	当社は、システムの保守、通信回線の障害、その他やむを得ない事情により、本サービスを一時的に中断又は停止することがあります。当社はこれによりユーザーに生じた損害について、一切の責任を負いません。

第12条　（本サービスの廃止）
当社は、当社の都合によりいつでも本サービスの全部又は一部の変更、追加、又は廃止を行うことができるものとします。

第13条　（規約の変更）
	1.	当社は、次に掲げる場合には、ユーザーの承諾なく、本規約を変更することができるものとし、本規約を変更する場合は、7日以上の予告期間をおいて、変更後の本規約の内容及び変更の効力発生日を当社のWebサイトに掲載する方法その他当社が適当と判断する方法により周知するものとし、変更後の本規約は、周知された効力発生日をもって効力を発生するものとします。
		(1)	変更がユーザーの一般の利益に適合するとき
		(2)	変更が、利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき
	2.	前項の場合を除き、当社はユーザーの同意を得て本規約の内容を変更するものとします。ただし、本規約の変更後、ユーザーが本サービスを利用した場合、本規約を変更することに同意したものとみなします。
	3.	本条に基づく本規約の変更について、ユーザーは、当社に対して損害賠償の請求を行うことはできないものとします。

第14条　（反社会的勢力の排除）
	1.	ユーザーは、次の各号のいずれにも該当しないことを表明し保証するとともに、将来にわたっても該当しないことを誓約するものとします。
		(1)	自ら（法人その他の団体にあっては、自らの役員を含みます。）が暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下「暴力団員等」といいます。）であること
		(2)	ユーザーが法人その他の団体の場合にあっては、暴力団員等が経営を支配していると認められる関係を有すること
		(3)	ユーザーが法人その他の団体の場合にあっては、暴力団員等が経営に実質的に関与していると認められる関係を有すること
		(4)	自ら若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、暴力団員等を利用していると認められる関係を有すること
		(5)	暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること
		(6)	ユーザーが法人その他の団体の場合にあっては、自らの役員又は自らの経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること
	2.	ユーザーは、自ら又は第三者を利用して次の各号のいずれか一にでも該当する行為を行わないことを誓約するものとします。
		(1)	暴力的な要求行為
		(2)	法的な責任を超えた不当な要求行為
		(3)	取引に関して、脅迫的な言動をし、又は暴力を用いる行為
		(4)	風説を流布し、偽計を用い又は威力を用いて当社の信用を毀損し、又は当社の業務を妨害する行為
		(5)	その他前各号に準ずる行為

第15条　（損害賠償）
ユーザーが本規約に違反し、当社に損害を与えた場合、ユーザーはその損害（合理的な弁護士費用を含みます。）を賠償する義務を負います。

第16条　（契約上の地位の譲渡）
	1.	ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位又は当社に対して有する権利若しくは当社に対して負う義務の全部又は一部を第三者に譲渡、貸与その他の処分をすることはできません。
	2.	当社は本サービスに関する事業を第三者（法人及び個人を含みます。）に譲渡した場合には、利用契約上の地位、利用契約に基づく権利及び義務並びにユーザーの情報その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項においてあらかじめ同意するものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、事業分割その他事業が移転するあらゆる場合を含むものとします。

第17条　（準拠法及び管轄）
	1.	本規約の解釈及び適用にあたっては、日本法を準拠法とします。
	2.	本サービスに関連して生じた一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。



制定日：2026年6月30日`;

export function TermsPage() {
  return (
    <div className="flex min-h-screen flex-col bg-[#EDF9FD] text-[#152C4D]">
      <Header mode="public" />
      <main className="flex-1 px-4 py-8 sm:px-6 sm:py-12">
        <article className="mx-auto max-w-4xl rounded-lg border border-[#C3EBEB] bg-white px-5 py-6 shadow-sm sm:px-8 sm:py-10">
          <pre
            className="whitespace-pre-wrap break-words font-sans text-sm leading-8 text-[#152C4D] sm:text-base"
            data-testid="terms-content"
          >
            {TERMS_TEXT}
          </pre>
        </article>
      </main>
    </div>
  );
}
